// extracted by mini-css-extract-plugin
export default {"permissionButtons":"workSpace_permissionButtons__zvXWG"};